/** True when body looks like TipTap / HTML storage (vs legacy plain text). */
export function isRichHtmlBody(body: string): boolean {
  const trimmed = body.trim();
  if (!trimmed) return false;
  if (trimmed.startsWith('<')) return true;
  return /<\/?(p|h[1-6]|ul|ol|li|table|blockquote|pre|div|img|iframe)\b/i.test(trimmed);
}

/** Plain-text excerpt for feed cards and previews. */
export function plainTextExcerpt(body: string, maxLen = 200): string {
  let text = body;
  if (isRichHtmlBody(body)) {
    text = body
      .replace(/<style[\s\S]*?<\/style>/gi, ' ')
      .replace(/<script[\s\S]*?<\/script>/gi, ' ')
      .replace(/<[^>]+>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .replace(/&amp;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"');
  }
  text = text.replace(/\s+/g, ' ').trim();
  if (text.length <= maxLen) return text;
  return `${text.slice(0, maxLen).trim()}…`;
}

export function plainTextToHtml(body: string): string {
  const escaped = body
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  return escaped
    .split('\n')
    .map((line) => (line.trim() ? `<p>${line}</p>` : '<p><br></p>'))
    .join('');
}
